export default __webpack_public_path__ + "./fonts/portafolio.9c342079.svg";